module.exports = __webpack_public_path__ + "static/media/sales-stream-money.29014021.svg";